const extractElements =
    (selector: string) =>
    (document: Document): HTMLElement[] => {
        const nodes = document.querySelectorAll(selector);
        return [].slice.call(nodes);
    };

const extractElementsByManySelectors = (selectors: string[]) =>
    extractElements(selectors.join(','));

const extractStylesheets = extractElements('link[rel="stylesheet"]');

const extractResourceHints = extractElementsByManySelectors([
    'link[rel="preload"]',
    'link[rel="prefetch"]',
    'link[rel="preconnect"]',
    'link[rel="dns-prefetch"]',
]);

const extractStyleTags = extractElements('style');

const extractSEOTags = extractElementsByManySelectors([
    'meta[property]',
    'meta[name="description"]',
]);

const extractBodyContent = extractElements('body>*:not(script)');

const extractScripts = extractElements('script[src]');

const extractInlineScripts = extractElements('script:not([src])');

const parse =
    (DomParser: typeof DOMParser) => (input: { url: string; html: string }) => {
        const parser = new DomParser();
        const source = parser.parseFromString(input.html, 'text/html');
        const output = {
            url: input.url,
            extracted: {
                stylesheets: extractStylesheets(source),
                styleTags: extractStyleTags(source),
                scripts: extractScripts(source),
                inlineScripts: extractInlineScripts(source),
                bodyContent: extractBodyContent(source),
                seoTags: extractSEOTags(source),
                resourceHints: extractResourceHints(source),
            },
        };
        return output;
    };

export { parse };
